// import { logout } from '../middlewares/auth'
import { mapActions } from 'vuex'
import axios from 'axios'
import Config from '@/api/config'
import Router from '@/router'
import Session from '@/api/utilities/Session'
import Store from '@/store'

class API {
  constructor () {
    // Set the default headers for the post call.
    axios.defaults.headers.common['Authorization'] = API.getAuthToken()
    axios.defaults.headers.post['Content-Type'] = 'application/json'
  }

  static getAuthToken () {
    if (Session.has('token')) {
      return 'Bearer ' + Session.get('token')
    }
    return ''
  }

  static store () {
    return {...mapActions('auth', ['logout'])}
  }

  refresh () {
    // Set the default headers for the post call.
    axios.defaults.headers.common['Authorization'] = API.getAuthToken()
    axios.defaults.headers.post['Content-Type'] = 'application/json'
    return this
  }

  post ({url, data}) {
    return new Promise((resolve, reject) => {
      axios.post(Config.ENGINE_PROXY_URL + url, data)
        .then(response => {
          if (response.data.SUCCESS) { resolve(response.data) }
          reject(response.data)
        })
        .catch(error => {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            if (error.response.status === 401) {
              Store.dispatch('auth/logout')
              Router.push('/login')
            }
          } else if (error.request) {
            /* The request was made but no response was received */
          } else {
            /* Something happened in setting up the request that triggered an Error */
          }
          reject(error.response.data)
        })
    })
  }
}

export default new API()



// WEBPACK FOOTER //
// ./src/api/utilities/API.js